module.exports = __webpack_public_path__ + "static/media/vocal_audition_evaluation.de4211cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vocal_audition_evaluation.jpg
// module id = 1277
// module chunks = 0